import IDataNotFound from "../../shared/interfaces/data-not-found.interface";

export const DATA_NOT_FOUND: IDataNotFound = {
    title: "No hemos encontrado programas",
    description: "No tienes programas en Fitpal"
};